import {whatsAppTemplatesMixin} from './WhatsAppTemplatesMixin'

export const whatsAppTemplateMixin = {
    mixins: [whatsAppTemplatesMixin],
    props: {
    },
    data: function() {
        return {}
    },
    computed: {
        isUnsubmitted: function () {
            return this.isTemplateUnsubmitted(this.template);
        },
        isReceived: function () {
            return this.isTemplateReceived(this.template);
        },
        isPending: function () {
            return this.isTemplatePending(this.template);
        },
        isApproved: function () {
            return this.isTemplateApproved(this.template);
        },
        isRejected: function () {
            return this.isTemplateRejected(this.template);
        },
        isPaused: function () {
            return this.isTemplatePaused(this.template);
        },
        isDisabled: function () {
            return this.isTemplateDisabled(this.template);
        },
        statusForDisplay: function () {
            return this.templateStatusForDisplay(this.template);
        }
    },
    methods: {
        isTemplateUnsubmitted: function (template) {
            return template.status === 'unsubmitted';
        },
        isTemplateReceived: function (template) {
            return template.status === 'received';
        },
        isTemplatePending: function (template) {
            return template.status === 'pending';
        },
        isTemplateApproved: function (template) {
            return template.status === 'approved';
        },
        isTemplateRejected: function (template) {
            return template.status === 'rejected';
        },
        isTemplatePaused: function (template) {
            return template.status === 'paused';
        },
        isTemplateDisabled: function (template) {
            return template.status === 'disabled';
        },
        templateStatusForDisplay: function(template) {
            switch (template.status) {
                case 'unsubmitted':
                    return '';
                case 'received':
                    return '<i class="fas fa-handshake"></i> Received';
                case 'pending':
                    return '<i class="fas fa-clock"></i> Reviewing';
                case 'approved':
                    return '<i class="fas fa-circle"></i> Approved';
                case 'rejected':
                    return '<i class="fas fa-exclamation-triangle"></i> Rejected';
                case 'paused':
                    return '<i class="fas fa-pause"></i> Paused';
                case 'disabled':
                    return '<i class="fas fa-exclamation-triangle"></i> Disabled';
                default:
                    return '';
            }
        }
    },
}